<template>
    <picture v-if="teamImage.origin">
        <source
            v-bind:srcset="`${teamImage.webp}`"
            type="image/webp"
        >
        <img
            v-bind:src="`${teamImage.origin}`"
            alt=""
            aria-hidden="true"
        >
    </picture>
    <LazyIcon v-else name="system:shieldColor" />
</template>

<script setup lang="ts">
    import { LazyIcon } from '@sbo/icons-vue';
    import { computed } from 'vue';
    import { getTeamImage } from '@/core/lib/teamLogoHelper';

    interface Props {
        teamId: number;
        alt: string;
    }

    const props = defineProps<Props>();

    const imageGlob = import.meta.glob('../../assets/images/teamLogo/*.{png,webp}', {
        eager: true,
        query: '?url',
    });

    const teamImage = computed(() => getTeamImage(imageGlob, `team-${props.teamId}`));
</script>

<style lang="scss" scoped>
    @import "@/components/fantasySelection/TeamLogo";
</style>
